import { countTPs } from "@/utils/kundenUtils";

// TreeNode Komponente für Downline-Baumstruktur (Organigramm-Stil)
export default function TreeNode({ node, level }) {
  const getTypColor = (typ, isCurrentUser) => {
    if (isCurrentUser) return "bg-blue-200 border-blue-500 text-blue-900 border-3";
    if (typ === "kaltkontakt") return "bg-orange-100 border-orange-300 text-orange-800";
    if (typ === "teampartner") return "bg-blue-100 border-blue-300 text-blue-800";
    if (typ === "kunde") return "bg-green-100 border-green-300 text-green-800";
    if (typ === "manager") return "bg-purple-100 border-purple-300 text-purple-800";
    return "bg-slate-100 border-slate-300 text-slate-800";
  };
  
  const getTypEmoji = (typ, isCurrentUser) => {
    if (isCurrentUser) return "👤";
    if (typ === "kaltkontakt") return "🥶";
    if (typ === "teampartner") return "👤";
    if (typ === "kunde") return "👤";
    if (typ === "manager") return "👑";
    return "👤";
  };
  
  const hasChildren = node.children && node.children.length > 0;
  const childCount = node.children?.length || 0;
  
  // Zähle alle TPs in der Downline (rekursiv)
  const tpCount = hasChildren ? node.children.reduce((sum, child) => sum + countTPs(child), 0) : 0;
  
  return (
    <div className="flex flex-col items-center">
      {/* Der Node selbst */}
      <div className={`px-4 py-3 rounded-lg border-2 ${getTypColor(node.typ, node.isCurrentUser)} shadow-md hover:shadow-lg transition-shadow min-w-[160px] text-center ${node.isCurrentUser ? 'ring-2 ring-blue-400 ring-offset-2' : ''}`}>
        <div className="text-2xl mb-1">{getTypEmoji(node.typ, node.isCurrentUser)}</div>
        <div className="font-bold text-sm mb-1">{node.name}</div>
        {node.stufe && node.stufe !== "keine" && (
          <div className="text-xs px-2 py-0.5 rounded-full bg-white border mt-1 inline-block">
            {node.stufe}
          </div>
        )}
        <div className="text-xs text-slate-600 mt-1 font-medium">
          Ges.: {tpCount} TP
        </div>
      </div>
      
      {/* Vertikale Linie nach unten (wenn Children vorhanden) */}
      {hasChildren && (
        <>
          <div className="w-0.5 h-12 bg-slate-400"></div>
          
          {/* Children Container */}
          <div className="relative flex justify-center gap-8">
            {/* Horizontale Verbindungslinie über den Children */}
            {childCount > 1 && (
              <div 
                className="absolute h-0.5 bg-slate-400" 
                style={{ 
                  top: '0px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: `${(childCount - 1) * 192}px`
                }}
              ></div>
            )}
            
            {/* Children */}
            {node.children.map((child) => (
              <div key={child.id} className="relative flex flex-col items-center">
                <div className="w-0.5 h-12 bg-slate-400"></div>
                <TreeNode node={child} level={level + 1} />
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
